import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { token } from '@atlaskit/tokens';

import previewNoSelection from './img/preview-no-selection.svg';
import squiggle from './img/content-preview-squiggle.svg';

const styles = cssMap({
	container: {
		position: 'relative',
		height: '100%',
	},
	squiggleWrapper: {
		marginBlockStart: token('space.250'),
		marginBlockEnd: token('space.300'),
	},
	skeletonBarFull: {
		width: '269px',
		height: '8px',
		backgroundColor: token('color.background.accent.gray.subtlest'),
	},
	skeletonBarShortWrapper: {
		marginBlockStart: token('space.150'),
	},
	skeletonBarShort: {
		width: '148px',
		height: '8px',
		backgroundColor: token('color.background.accent.gray.subtlest'),
	},
	skeletonBarBottom: {
		width: '94px',
		height: '6px',
		backgroundColor: token('color.background.accent.gray.subtlest'),
		position: 'absolute',
		bottom: token('space.0'),
		left: token('space.0'),
	},
});

export const ContentPreviewPlaceholder = (): React.JSX.Element => {
	return (
		<Box xcss={styles.container} testId="content-preview-placeholder">
			<img src={previewNoSelection} alt="" aria-hidden="true" width="100%" />
			<Box xcss={styles.squiggleWrapper}>
				<img src={squiggle} alt="" aria-hidden="true" width="84" height="15" />
			</Box>
			<Stack space="space.150">
				<Box xcss={styles.skeletonBarFull} />
				<Box xcss={styles.skeletonBarFull} />
			</Stack>
			<Box xcss={styles.skeletonBarShortWrapper}>
				<Box xcss={styles.skeletonBarShort} />
			</Box>
			<Box xcss={styles.skeletonBarBottom} />
		</Box>
	);
};
